import {
    AccessorsMutatorsDecorator
} from "../../helpers";
import {
    TranslatableModel
} from "./translatable-model";

export class Policy extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return ['cancellation_policy', 'terms_and_conditions'];
    }
    
    static get validationModel() {
        
        return {
            cancellation_policy: {
                label: 'CANCELLATION_POLICY_IN_ENGLISH',
                commonLabel: 'Cancellation Policy',
                messages: {
                    required: 'ADD_CANCELLATION_IN_EN'
                }
            },
            cancellation_policy_ar: {
                label: 'CANCELLATION_POLICY_IN_ARABIC',
                commonLabel: 'Cancellation Policy',
                messages: {
                    required: 'ADD_CANCELLATION_IN_AR'
                }
            }
        };
    }

}

AccessorsMutatorsDecorator('id', ...Policy.translatableAttributesWithLanguageAliases,
    'property_id',
    'deposit_amount_type','deposit_amount', 
    'full_amount_payment', 'include_taxes', 'capture_card',
    'cancellations_status',
    'full_charge_status', 'full_charge_type', 'full_charge_period', 
    'partial_charge_status','partial_charge_type', 'partial_charge_amount', 'partial_charge_period',
    'no_charge_status', 'no_charge_period', 
    'confirmation_type',
    'checkin_time', 'checkout_time', 
    'activate_previous_day_calculations',
    'late_checkout_status', 'late_checkout_time', 'late_charge_type', 'late_charge_amount', 'open_editor')(Policy);


// WEBPACK FOOTER //
// ./src/pms-api/models/policy.model.js